// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__MYaRV","question":"Question_question__1V8u3","description":"Question_description__2SV34"};